import * as Yup from 'yup';

export default function getSelectSchema(fieldName: string, customMessage: string="") {
  return Yup.mixed<any>().required(customMessage || `${fieldName} is required.`);
}
